import { traitRegistry } from '../../../../../registry/Registry';
import { flatten, sortByFunc, uniq } from '../../../../../utils/helper/lodash_replacements';
export class AspectKeyReduced {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspectKey() {
        return this.parent;
    }
    get aspect() {
        return this.aspectKey.aspect;
    }
    get baseForThisKey() {
        return this.aspectKey.keyEnabled.enabledTraits;
    }
    get baseMergedFromUnifier() {
        if (!this.aspectKey.reg.unifier)
            return [];
        const traitKeys = traitRegistry.reverseUnifier[this.aspectKey.reg.unifier];
        const aspectKeys = traitKeys.map((traitKey) => this.aspectKey.aspectScope.aspectKey(traitKey));
        // fallback for initalClass (opacity0) of animations
        const enabled = flatten(aspectKeys.map((aspectKey) => aspectKey.keyEnabled.enabledTraits));
        if (enabled.length > 0) {
            return enabled.sort(
            // conditionTrueTraits
            sortByFunc((at) => 0 - at.prio));
        }
        /*
        const withConditionTrue = flatten(aspectKeys.map(aspectKey => aspectKey.keyEnabled.conditionTrueTraits));
        if (withConditionTrue.length > 0) {
          return withConditionTrue.sort(
            // conditionTrueTraits
            sortByFunc((at: AttachedTrait) => 0 - at.prio)
          );
        }
        // fallback for initalClass (opacity0) of animations
        const enabled = flatten(aspectKeys.map(aspectKey => aspectKey.keyEnabled.enabledTraits));
        const enableSorted = enabled.sort(
          // conditionTrueTraits
          sortByFunc((at: AttachedTrait) => 0 - at.prio)
        );
        if (enableSorted.length > 0) {
          return [enableSorted[enableSorted.length - 1]];
        }
        */
        return [];
    }
    get reductionBase() {
        if (!this.aspectKey.reg)
            return [];
        if (this.aspectKey.reg.unifier) {
            return uniq(this.baseMergedFromUnifier);
        }
        return uniq(this.baseForThisKey);
    }
    get candidates() {
        return this.reductionBase.filter((at) => (at.reg.unifier || at.key) === (this.aspectKey.reg.unifier || this.aspectKey.traitKey));
    }
    get canKeep() {
        const usedTraitGroups = [];
        return this.candidates.filter((candidate, index) => {
            if (!candidate.trait.isMultiple)
                return index === 0;
            if (candidate.traitGroup.length === 0 || candidate.traitGroup === '#FFFFFF')
                return true;
            if (usedTraitGroups.includes(candidate.traitGroup))
                return false;
            usedTraitGroups.push(candidate.traitGroup);
            return true;
        });
    }
    get reducedTraits() {
        return this.canKeep.filter((at) => at.key === this.aspectKey.traitKey);
    }
}
